import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=7ed96f14&scoped=true&"
import script from "./sidebar.vue?vue&type=script&lang=ts&"
export * from "./sidebar.vue?vue&type=script&lang=ts&"
import style0 from "./sidebar.vue?vue&type=style&index=0&id=7ed96f14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed96f14",
  null
  
)

export default component.exports